export default {
  Main: '/',
  SignIn: '/sign-in',
  ForgotPassword: '/forgot-password',
  SetNewPassword: '/set-new-password',
  ResetPassword: '/reset-password',
  Register: '/register',
  Dashboard: '/dashboard',
  Billing: '/billing',
  PatientDocument: '/patient-document',
  FormSubmission: '/form-submission',
  VerifyIdentity: '/verify-identity'
};
